import { render, staticRenderFns } from "./paymentModal.vue?vue&type=template&id=55ee86cc"
import script from "./paymentModal.vue?vue&type=script&lang=js"
export * from "./paymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports